module.exports = __webpack_public_path__ + "static/media/con_spa_two_way_rad.9b940d6b.jpg";